import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ReactVisibilitySensor from 'react-visibility-sensor';
export const VisibilitySensor = (props) => {
    const { active, children, intervalDelay, onChange, partialVisibility } = props;
    return (_jsx(ReactVisibilitySensor, Object.assign({ active: active, intervalDelay: intervalDelay, onChange: onChange, 
        // FIXME: react-visibility-sensor の型定義が間違っているため、一時的に @ts-ignore で回避
        // @ts-ignore
        partialVisibility: partialVisibility }, { children: children })));
};
